import { cn } from "@marketing-sites/utils/cn";

type TooltipProps = {
  /** The tooltip text to display */
  tooltip: string;
  children: React.ReactNode;
  className?: string;
  align?: "start" | "center" | "end";
  /** When provided, sets the id on the tooltip element. The consumer should add aria-describedby={id} to their interactive element. */
  id?: string;
};

export const Tooltip = ({
  tooltip,
  children,
  className,
  align = "center",
  id,
}: TooltipProps) => {
  const alignClasses = {
    start: "left-0",
    center: "left-1/2 -translate-x-1/2",
    end: "right-0",
  };

  return (
    <span className={cn("group relative block", className)}>
      {children}
      <span
        className={cn(
          "z-nav-tooltip absolute top-full w-max max-w-[225px] pt-5",
          alignClasses[align],
          "hidden",
          "group-focus-within:block group-hover:block",
        )}
      >
        <span
          role="tooltip"
          {...(id ? { id } : { "aria-hidden": "true" })}
          className="bg-nav-background-highlight text-nav-content-primary block rounded px-3.5 py-3 font-sans text-sm"
        >
          {tooltip}
        </span>
      </span>
      <span
        className={cn(
          "border-b-nav-background-highlight absolute left-1/2 top-full mt-3.5 h-0 w-0 -translate-x-1/2 border-x-8 border-b-8 border-x-transparent",
          "hidden",
          "group-focus-within:block group-hover:block",
        )}
      ></span>
    </span>
  );
};
